import { normalizeAttribute } from "../../utils/domUtils";
import Sidebar from "../../components/Sidebar";
import { ContainerNode, render } from "preact";

class SidebarWebComponent extends HTMLElement {
  constructor() {
    super();
    this.attachShadow({ mode: "open" });
  }

  attributeChangedCallback(_name: string, oldValue: string, newValue: string) {
    if (oldValue !== newValue) {
      this.renderComponent();
    }
  }

  connectedCallback() {
    this.renderComponent();
  }

  getPropsFromAttributes() {
    const props: Record<string, string> = {};

    for (let index = 0; index < this.attributes.length; index++) {
      const attribute = this.attributes[index];
      const normalizedName = normalizeAttribute(
        attribute.name.replace(/^data-/, "")
      );
      props[normalizedName] = attribute.value;
    }

    return props;
  }

  renderComponent() {
    const props = this.getPropsFromAttributes();
    render(<Sidebar {...props} />, this.shadowRoot as ContainerNode);
  }
}

export default SidebarWebComponent;
